import * as React from "react"

import Layout from "../components/layout"
import Seo from "../components/seo"
import { graphql, StaticQuery } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image";

const tracks = {"A": "Track A", "B": "Track B", "C": "Track C"}
const types = {"keynote": "Keynote", "special": "Guest Session", "cochairtalk": "Co-Chair Talk Session", "platinum": "Platinum Sponsor", "gold": "Gold Sponsor", "comingsoon": "TBD"}

const SchedulePage = () => (
  <Layout noBanner={true}>
    <Seo title="Schedule" />
    <StaticQuery
      query={graphql`
        query ScheduleQuery {
          allTimetableJson {
            edges {
              node {
                jsonId
                title
                description
                date
                beginsTime
                endsTime
                trackId
                type
                speakers {
                  jsonId
                  type
                  name
                  company
                  title
                  twitter
                  github
                  profile
                  image {
                    childImageSharp {
                      gatsbyImageData(width: 100, height: 100)
                    }
                  }
                }
                youtubeUrl
                slideUrl
              }
            }
          }
        }
      `}
      render={data => {
        const itemsPerDate = data.allTimetableJson.edges.map(edge => edge.node).reduce((dates, item) => {
          if (dates[item.date]) {
            dates[item.date].push(item);
          } else {
            dates[item.date] = [item];
          }
          return dates;
        }, {});
        return (
          <section id="schedules" className="schedule section-padding-top">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <div className="section-title-header text-center">
                    <h1
                      className="section-title wow fadeInUp"
                      data-wow-delay="0.2s"
                    >
                      Schedule
                    </h1>
                    <p className="wow fadeInDown" data-wow-delay="0.2s">
                      タイムテーブル
                    </p>
                  </div>
                </div>
              </div>
              {Object.keys(itemsPerDate).map((date, index) => {
                const itemsPerTimeSpan = itemsPerDate[date].reduce((times, item) => {
                  const timeSpan = `${item.beginsTime}/${item.endsTime}`;
                  if (times[timeSpan]) {
                    times[timeSpan].push(item);
                  } else {
                    times[timeSpan] = [item];
                  }
                  return times;
                }, {});
                return (
                  <div className="day" key={index}>
                    <div className="row mb-3 wow fadeInDown" data-wow-delay="0.3s">
                      <h2 className="col-12 text-center">
                        DAY {index + 1}: {date}
                      </h2>
                    </div>
                    <div className="schedule-area wow fadeInDown" data-wow-delay="0.3s">
                      <div className="tracks d-none d-md-flex">
                        <div className="timespan invisible"></div>
                        {Object.values(tracks).map((track, index) => (
                          <div className="card" key={index}>
                            <h4>{track}</h4>
                          </div>
                        ))}
                      </div>
                      {Object.keys(itemsPerTimeSpan).map((timeSpan, index) => (
                        <div className="timegroup" key={index}>
                          <div className="card timespan"><span className="d-md-none">{date}</span> {timeSpan.split('/')[0]}<br className="d-none d-md-inline" /> - <br className="d-none d-md-inline" />{timeSpan.split('/')[1]}</div>
                          {itemsPerTimeSpan[timeSpan].map((item, index) => {
                            const labels = (
                              <div className="schedule-labels">
                                {item.trackId && (
                                  <span className="track">
                                      Track {item.trackId}
                                    </span>
                                )}
                                {item.type && item.type !== 'cfp' && (
                                  <span className={'type ' + item.type}>{types[item.type]}</span>
                                )}
                              </div>
                            )
                            const popupId = item.jsonId.toLowerCase();
                            const popup = (
                              <div
                                id={popupId}
                                className="container schedule-popup mfp-hide"
                              >
                                <div className="content">
                                  <div className="row session">
                                    <div className="col-lg-12">
                                      {labels}
                                      <p className="timeframe">
                                        {item.date} {item.beginsTime} - {item.endsTime}
                                      </p>
                                      <h3>
                                        {item.id && '[' + item.id + '] '}
                                        {item.title}
                                      </h3>
                                      <p className="description">
                                        {item.description}
                                      </p>
                                    </div>
                                  </div>
                                  {(item.youtubeUrl ||
                                    item.slideUrl) && (
                                    <div className="row media">
                                      {item.youtubeUrl && (
                                        <div className="col-lg-6">
                                          <div className="aspect" data-youtube-url={item.youtubeUrl}></div>
                                        </div>
                                      )}
                                      {item.slideUrl && (
                                        <div className="col-lg-6">
                                          <div className="aspect" data-slide-url={item.slideUrl}></div>
                                        </div>
                                      )}
                                    </div>
                                  )}
                                  {item.speakers &&
                                    item.speakers.map((speaker, i) => {
                                      const image = getImage(speaker.image)
                                      return (
                                        <div key={i} className="row speaker">
                                          <div className="col-lg-6">
                                            <div className="image">
                                              <GatsbyImage className="img-fluid" image={image} alt="" />
                                            </div>
                                            <div className="info">
                                              <p className="title">
                                                {speaker.company}{' '}
                                                {speaker.title}
                                              </p>
                                              <h3 className="ts-title">
                                                {speaker.name}
                                              </h3>
                                              <div className="social">
                                                {speaker.twitter !== '' && (
                                                  <a
                                                    href={
                                                      'https://twitter.com/' +
                                                      speaker.twitter
                                                    }
                                                  >
                                                    <i className="lni lni-twitter-filled" />
                                                    {speaker.twitter}
                                                  </a>
                                                )}
                                                {speaker.github !== '' && (
                                                  <a
                                                    href={
                                                      'https://github.com/' +
                                                      speaker.github
                                                    }
                                                  >
                                                    <i className="lni lni-github-original" />
                                                    {speaker.github}
                                                  </a>
                                                )}
                                              </div>
                                            </div>
                                          </div>
                                          <div className="col-lg-6">
                                            <p>{speaker.profile}</p>
                                          </div>
                                        </div>
                                      )
                                    })}
                                </div>
                              </div>
                            )
                            return (
                              <div className="card" key={index}>
                                <a
                                  href={'#' + popupId}
                                  className="popup"
                                  data-effect="mfp-zoom-in"
                                >
                                  <div className="card-header">
                                    {labels}
                                    {item.type && (item.type === 'platinum' || item.type === 'gold') && (
                                      <p className="sponsor-name">{item.speakers[0].company}</p>
                                    )}
                                    <h4>{item.title}</h4>
                                    {item.speakers.map((speaker, index) => {
                                      const image = getImage(speaker.image)
                                      return (
                                        <div className="speaker" key={index}>
                                          <div className="images-box">
                                            <GatsbyImage className="img-fluid" image={image} alt="" />
                                          </div>
                                          <h5 className="name">{speaker.name}</h5>
                                        </div>
                                      )
                                    })}
                                  </div>
                                </a>
                                {popup}
                              </div>
                            )
                          })}
                          {[1, 2, 3].slice(itemsPerTimeSpan[timeSpan].length).map((_, index) => (
                            <div className="card empty" key={index}></div>
                          ))}
                        </div>
                      ))}
                    </div>
                  </div>
                )
              })}
            </div>
          </section>
        )
      }}
    />
  </Layout>
)

export default SchedulePage
